import * as React from "react";
const SvgViewfinderFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M21.95 11H16a1 1 0 1 0 0 2h5.95A10 10 0 0 1 13 21.95V16a1 1 0 1 0-2 0v5.95A10 10 0 0 1 2.05 13H8a1 1 0 1 0 0-2H2.05A10 10 0 0 1 11 2.05V8a1 1 0 1 0 2 0V2.05c4.632.46 8.334 4.08 8.92 8.673z" }));
export default SvgViewfinderFill;
